import api from './api';

export interface DriverRequest {
  id: number;
  driver_id: number;
  company_id: number;
  request_type: 'type_change' | 'vehicle_associate' | 'vehicle_disassociate';
  status: 'pending' | 'approved' | 'rejected';
  request_data: Record<string, unknown>;
  created_at: string;
  reviewed_by?: number;
  reviewed_at?: string;
  review_note?: string;
  // JOIN fields
  driver_name?: string;
  current_driver_type?: string;
  truck_plate?: string;
  truck_make?: string;
  truck_model?: string;
}

function formatRequestDescription(req: DriverRequest): string {
  switch (req.request_type) {
    case 'type_change': {
      const newType = req.request_data.new_type_label || req.request_data.new_type || 'unknown';
      return `Change driver type to ${newType}`;
    }
    case 'vehicle_associate': {
      const plate = req.truck_plate || req.request_data.license_plate || 'unknown';
      return `Associate truck ${plate} with company`;
    }
    case 'vehicle_disassociate': {
      const plate = req.truck_plate || req.request_data.license_plate || 'unknown';
      return `Remove truck ${plate} from company`;
    }
    default:
      return 'Unknown request';
  }
}

export const driverRequestApi = {
  async getPendingCount(): Promise<number> {
    const response = await api.get('/driver-requests/count');
    return response.data?.count || 0;
  },

  async listPending(): Promise<DriverRequest[]> {
    const response = await api.get('/driver-requests', { params: { status: 'pending' } });
    return response.data || [];
  },

  async approve(id: number, reviewNote?: string): Promise<void> {
    await api.put(`/driver-requests/${id}/approve`, { review_note: reviewNote });
  },

  async reject(id: number, reviewNote?: string): Promise<void> {
    await api.put(`/driver-requests/${id}/reject`, { review_note: reviewNote });
  },

  formatDescription: formatRequestDescription,
};

export default driverRequestApi;
